import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

import { Text } from './components/textElements'
import Grid from './components/grid'

import colors from './styles/colors'
import easings from './styles/easings'
import { devicesMax } from './styles/breakpoints'

import frame from './../img/frame-border.png'

export const StyledBaseView = styled.main`
  position: relative;
  background: #e6c3b4;
  color: ${colors.red};

  padding: 4.25rem 2.5rem;
  text-align: center;
`

export const Frame = styled.div`
  overflow: hidden;

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;

    width: calc(100% - 1rem);
    height: calc(100% - 1rem);

    border: solid;
    border-image: url(${frame});
    border-image-slice: ${260 / 2 - 1};
    border-image-width: 100px;

    transform: translate(-50%, -50%);
  }

  ::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;

    width: calc(100% - 3.1rem);
    height: calc(100% - 3.1rem);

    border: 2px dashed ${colors.red};
    transform: translate(-50%, -50%);
  }
`

export const Logo = styled.img`
  position: absolute;
  z-index: 1;
  top: 6.5px;
  left: 50%;

  width: auto;
  height: 33.5px;

  @media ${devicesMax.mobile.lg} {
    top: 5.5px;
  }

  transform: translateX(-50%);
  background: #e6c3b4;
`

export const Section = styled(motion.section)`
  position: relative;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  min-height: calc(100vh - 8.5rem);
`

export const IntroLine = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  width: 100%;

  transform: translate(-50%, -50%);
`

export const AnswersGrid = styled(Grid)`
  @media ${devicesMax.mobile.lg} {
    grid-template-columns: 1fr;
  }
`

export const Pagination = styled(motion.div)`
  position: absolute;
  bottom: 50px;
  left: 50%;

  max-width: 100%;

  transform: translateX(-50%);

  display: grid;
  grid-auto-flow: column;
  grid-gap: 1.5rem;

  opacity: 0;

  @media ${devicesMax.mobile.lg} {
    bottom: 15px;
    grid-gap: 0.5rem;
  }

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;

    width: 100%;
    height: 2px;

    transform: translateY(-50%);

    background: ${colors.red};
  }
`

export const PaginationItem = styled.div`
  position: relative;

  width: 28px;
  height: 28px;

  transition: all 300ms ${easings.easeInOutQuart};

  :hover {
    transform: ${props => props.isCompleted && 'scale(1.1)'};
  }

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;

    width: ${props => (props.isCurrent ? '50px' : '28px')};
    height: ${props => (props.isCurrent ? '50px' : '28px')};
    transform: translate(-50%, -50%);

    @media ${devicesMax.mobile.lg} {
      width: 28px;
      height: 28px;
    }

    border: 2px solid ${colors.red};
    border-radius: 50%;

    background: ${props => (props.isCurrent ? '#f5e0d7' : '#e6c3b4')};
    background: ${props => props.isCompleted && '#d69c92'};
    cursor: ${props => props.isCompleted && 'pointer'};
    transition: all 800ms 0.5s ${easings.easeInOutQuart};
  }

  ::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;

    width: 10px;
    height: 10px;

    background: #e6c3b4;
    border: 2px solid ${colors.red};

    transform: translate(-50%, -50%) rotate(45deg) scale(${props => (props.isCurrent ? 0 : 1)});
    transform-origin: center;
    transition: all 800ms 0.5s ${easings.easeInOutQuart};
    pointer-events: none;
  }

  ${Text} {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    margin: 0;

    transform: translate(-50%, -50%) scale(${props => (props.isCurrent ? 1 : 0)});
    opacity: ${props => (props.isCurrent ? 1 : 0)};

    font-size: 1.5rem;

    transform-origin: center;
    transition: all 800ms 0.5s ${easings.easeInOutQuart};
    pointer-events: none;

    @media ${devicesMax.mobile.lg} {
      font-size: 1rem;
    }
  }
`

export const CaptionAffix = styled(Text)`
  position: absolute;
  top: 1rem;
  left: 1.5rem;

  font-style: italic;
`

export const CaptionArea = styled.textarea`
  appearance: none;
  outline: none;
  resize: none;

  display: block;
  width: 100%;
  padding: 1.5rem;
  padding-top: 3rem;
  margin: 0.5rem 0 2rem;

  font-style: italic;
  text-align: left;

  border: none;
  border-radius: 30px;
  background: #f5e0d7;

  color: ${colors.red};
`
